import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

Vue.use(SimpleVueValidation);